var QuestionSetLabel = /** @class */ (function () {
    function QuestionSetLabel() {
        this.id = null;
        this.display_order = 0;
        this.label = "";
    }
    Object.defineProperty(QuestionSetLabel.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSetLabel.prototype, "skipScoring", {
        get: function () {
            return this._skipScoring;
        },
        set: function (id) {
            this._skipScoring = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSetLabel.prototype, "display_order", {
        get: function () {
            return this._display_order;
        },
        set: function (order) {
            this._display_order = order;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSetLabel.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (lbl) {
            this._label = lbl;
        },
        enumerable: true,
        configurable: true
    });
    return QuestionSetLabel;
}());
export { QuestionSetLabel };



// WEBPACK FOOTER //
// ./src/app/shared/models/question-set-label.ts.pre-build-optimizer.js